<template>
  <div class="booking-confirmation main-content">
    <el-descriptions :column="24" :colon="false">
      <el-descriptions-item :span="3.5" label="Booking Received by Carrier:" />
      <el-descriptions-item :span="16.5">
        <el-tag :type="acLabel.type">{{ acLabel.label }}</el-tag>
        <el-tag type="info" style="margin-left: 5px;">{{ acEdiReceipt.dateCreated }}</el-tag>
        <el-tooltip class="item" effect="dark" :content="acEdiReceipt.remarks" placement="bottom-end">
          <span v-if="acLabel.type === 'warning'">{{ remarks }}</span>
        </el-tooltip>
      </el-descriptions-item>
      <el-descriptions-item :span="4">
        <div style="display: flex">
          <el-button type="primary" plain @click="syncData">Update to booking information</el-button>
          <el-tooltip class="item" effect="dark" :content="help" placement="bottom-end">
            <el-tag style="margin: 3px;">?</el-tag>
          </el-tooltip>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions :column="14" :colon="false">
      <el-descriptions-item :span="2" label="Booking Confirmation Version:" />
      <el-descriptions-item :span="8">
        <div style="display: flex">
          <cargo-pagination
            layout="prev, pager, next"
            :limit="1"
            :page="page"
            :total="ediReceiptData.length"
            @pagination="changeEdiReceiptVersion"
          />
          <el-select v-model="filter.differentStatus" placeholder="-Please select-" :clearable="false" style="width:300px;margin-top: 7px;" @change="reloadDifferent">
            <el-option
              v-for="item in chooseDifferent"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </div>
      </el-descriptions-item>
      <el-descriptions-item :span="2" label="Latest Amendment Time:" />
      <el-descriptions-item :span="2">
        <el-tag type="info">{{ selectData.time + ' (UTC)' }}</el-tag>
      </el-descriptions-item>
    </el-descriptions>
    <h1 style="text-align: center;">{{ selectStatus }}</h1>
    <div style="display: flex">
      <h2>S/O NO.</h2>
      <p :class="differentSoNo ? 'warning': ''" style="margin: 9.6px 20px;">{{ selectData.soNo }}</p>
      <h2>MB/L NO.</h2>
      <p :class="differentMbl ? 'warning': ''" style="margin: 9.6px 20px;">{{ selectData.mbl }}</p>
    </div>
    <div class="grid-view">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            v-if="port.rowData && port.rowData.length > 0"
            :show-side-bar="false"
            :grid-options="port.gridOptions"
            :column-defs="port.columnDefs"
            :row-data="port.rowData"
            grid-style="height:300px;"
            :wrap-text="true"
          />
          <cargo-ag-grid
            v-if="time.rowData && time.rowData.length > 0"
            style="margin-top: 20px;"
            :show-side-bar="false"
            :grid-options="time.gridOptions"
            :column-defs="time.columnDefs"
            grid-style="height:100%;"
            :row-data="time.rowData"
          />
        </div>
      </div>
    </div>
    <span style="height: 28px;" />
    <el-descriptions v-for="(item,index) in containerData" :key="index" :column="10" border direction="vertical">
      <el-descriptions-item label="Item No.">
        <span :class="item.differentFields && item.differentFields['itemNo'] ? 'warning': ''">{{ item.itemNo }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="Container No.">
        <span :class="item.differentFields && item.differentFields['containerNo'] ? 'warning': ''">{{ item.containerNo }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="EQ Size">
        <span :class="item.differentFields && item.differentFields['eqSize'] ? 'warning': ''">{{ item.eqSize }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="EQ Type">
        <span :class="item.differentFields && item.differentFields['eqType'] ? 'warning': ''">{{ item.eqType }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="Description of Goods">
        <span :class="item.differentFields && item.differentFields['goodDescriptions'] ? 'warning': ''">{{ item.goodDescriptions }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="Quantity">
        <span :class="item.differentFields && item.differentFields['quantity'] ? 'warning': ''">{{ item.quantity }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="Packing">
        <span :class="item.differentFields && item.differentFields['packingName'] ? 'warning': ''">{{ item.packingName }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="Gross Weight">
        <span :class="item.differentFields && item.differentFields['weight'] ? 'warning': ''">{{ item.weight }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="CBM">
        <span :class="item.differentFields && item.differentFields['cbm'] ? 'warning': ''">{{ item.cbm }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="SOC/COC">
        <span :class="item.differentFields && item.differentFields['socCoc'] ? 'warning': ''">{{ item.socCoc }}</span>
      </el-descriptions-item>
      <el-descriptions-item :label-style="{display:'none'}" :content-style="{padding:0}">
        <el-descriptions :column="2" border :colon="false">
          <el-descriptions-item label="Empty Equipment Pick Up Address" :span="2">
            <span :class="item.differentFields && item.differentFields['facilityDetails'] ? 'warning': ''">{{ item.facilityDetails }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="Delivery Address" :span="2">
            <span :class="item.differentFields && item.differentFields['equipmentDelivery'] ? 'warning': ''">{{ item.equipmentDelivery }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>
    </el-descriptions>
    <div v-if="currentCount<totalContainer" class="show-more" @click="loadMoreContainer">
      <p style="margin-bottom: 5px">{{ `${totalContainer - currentCount} more` }}</p>
      <i class="el-icon-d-arrow-right" style="transform: rotate(90deg)" />
    </div>
  </div>
</template>
<script>
import {
  queryEdiReceiptContainers,
  queryEdiReceiptTimes,
  queryAcEdiReceipt,
  queryEdiReceiptPorts } from '@/api/booking/job'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'BookingConfirmation',
  components: { CargoAdvanceSelect },
  props: {
    ediReceiptData: { type: Array, required: true },
    jobNo: { type: String, required: true }
  },
  data() {
    return {
      totalContainer: 0,
      currentCount: 10,
      selectData: {},
      selectStatus: '',
      differentSoNo: false,
      differentMbl: false,
      timeData: [],
      portData: [],
      filter: {
        receiptUuid: '',
        differentStatus: 1,
        targetReceiptUuid: [],
        pageSize: 10,
        pageNum: 1
      },
      containerData: [],
      acEdiReceipt: {
        remarks: ''
      },
      help: 'Synchronize the lasest "Booking Confirmation" to the "Booking Tab"',
      acLabel: {
        label: '',
        type: ''
      },
      index: 1,
      page: 1,
      chooseDifferent: [{
        code: 1,
        name: 'Display the latest'
      },
      {
        code: 2,
        name: 'Display recent updates'
      },
      {
        code: 3,
        name: 'Display all updates'
      }],
      port: {
        gridOptions: {
        },
        rowData: [],
        columnDefs: [{
          headerName: 'From',
          field: 'pol',
          flex: 1,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        },
        {
          headerName: 'To',
          field: 'pod',
          flex: 1,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        },
        {
          headerName: 'Mode of Transport',
          field: 'vvi',
          flex: 1,
          cellRenderer: (params) => {
            return this.modeOfTransportLabel(params.data)
          }
        },
        {
          headerName: 'ETD',
          field: 'etd',
          flex: 1,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        },
        {
          headerName: 'ETA',
          field: 'eta',
          flex: 1,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }]
      },
      time: {
        gridOptions: {
        },
        rowData: [],
        columnDefs: [{
          headerName: 'Event',
          width: 200,
          field: 'event',
          flex: 1
        },
        {
          headerName: 'Location',
          width: 300,
          field: 'location',
          flex: 1,
          cellRenderer: (params) => {
            return this.locationLabel(params.data)
          }
        },
        {
          headerName: 'Cut-off Date/Time',
          width: 400,
          field: 'time',
          flex: 1,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }]
      }
    }
  },
  computed: {
    remarks: {
      get() {
        const remarks = this.acEdiReceipt.remarks
        return remarks && remarks.length > 30 ? remarks.substring(0, 20) + '...' : remarks
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.ediReceiptData) {
        this.changeEdiReceiptVersion()
      }
      this.loadAcEdiReceipt()
    },
    loadAcEdiReceipt() {
      queryAcEdiReceipt({ jobNo: this.jobNo }).then(res => {
        this.acEdiReceipt = res.data
        if (this.acEdiReceipt) {
          this.changeAcLabel(this.acEdiReceipt.status)
        }
      })
    },
    changeAcLabel(status) {
      let label = ''
      let type = ''
      if (status === 'AP' || status === '8') {
        label = 'Received'
        type = 'success'
      }
      if (status === 'AD') {
        label = 'Warning'
        type = 'warning'
      }
      if (status === 'RE' || status === '4') {
        label = 'Rejected'
        type = 'danger'
      }
      if (status === '7') {
        label = 'Confirmed'
        type = ''
      }
      this.acLabel.label = label
      this.acLabel.type = type
    },
    changeEdiReceiptVersion(p) {
      const index = p ? p.page : this.ediReceiptData.length
      this.filter.differentStatus = index === 1 ? 1 : 2
      this.page = index
      this.index = index - 1
      this.filter.receiptUuid = this.ediReceiptData[this.index].uuid
      this.selectData = this.ediReceiptData[this.index]
      this.selectStatus = this.bookingConfirmationLabel()
      if (this.ediReceiptData.length > 1) {
        this.reloadDifferent(this.filter.differentStatus)
      } else {
        this.reload()
      }
      this.differentSoNo = this.compare(index - 1, index - 2, this.ediReceiptData, 'soNo')
      this.differentMbl = this.compare(index - 1, index - 2, this.ediReceiptData, 'mbl')
    },
    reload() {
      queryEdiReceiptTimes(this.filter).then(res => {
        this.time.rowData = res.data
      })
      queryEdiReceiptPorts(this.filter).then(res => {
        this.port.rowData = res.data
      })
      this.loadContainer()
    },
    loadMoreContainer() {
      this.currentCount += 10
      this.loadContainer()
    },
    loadContainer() {
      this.filter.pageNum = this.currentCount / 10
      queryEdiReceiptContainers(this.filter).then(res => {
        this.containerData = this.filter.pageNum > 1 ? this.containerData.concat(res.data.list) : res.data.list
        this.totalContainer = Number(res.data.total)
      })
    },
    /**
     * 客户重新要求移除对应参数后的数字
     * Common value(s):
     * 1 Maritime transport
     * 2 Rail transport
     * 3 Road transport
     * 8 Inland water transport
     * 23 Combined rail/road
     * 83 Combined waterway/road
     */
    modeOfTransportLabel(data) {
      let result = ''
      if (data.transCode) {
        switch (data.transCode) {
          case '1':
            result += this.addSpan2(data, 'Maritime transport')
            break
          case '2':
            result += this.addSpan2(data, 'Rail transport')
            break
          case '3':
            result += this.addSpan2(data, 'Road transport')
            break
          case '8':
            result += this.addSpan2(data, 'Inland water transport')
            break
          case '23':
            result += this.addSpan2(data, 'Combined rail/road')
            break
          case '83':
            result += this.addSpan2(data, 'Combined waterway/road')
            break
        }
      } else {
        result += this.addSpan(data, 'Vessel：', 'vessel')
        result += this.addSpan(data, 'Voyage：', 'voyage')
        result += this.addSpan(data, 'IMO Code：', 'imoCode')
      }
      return result
    },
    addSpan(data, label, field) {
      const color = 'style="color:sandybrown"'
      const isDifferent = data['differentFields'] && data['differentFields'][field]
      return '<span ' + (isDifferent ? color : '') + '>' + label + data[field] + '</span></br>'
    },
    addSpan2(data, field) {
      const color = 'style="color:sandybrown"'
      const isDifferent = data['differentFields'] && data['differentFields']['imoCode']
      return '<span ' + (isDifferent ? color : '') + '>' + field + '</span></br>'
    },
    reloadDifferent(type) {
      this.differentSoNo = false
      this.filter.differentStatus = type
      // 边界判断
      if (type === 1 || type === '') {
        // 重新加载数据
        this.filter.targetReceiptUuid = []
      }

      const { index, ediReceiptData } = this
      if (ediReceiptData.length === 1) {
        return
      }
      if (type === 2) {
        // 重新加载数据
        const targetReceiptUuids = []
        if (index === 0) {
          return
        }
        targetReceiptUuids.push(ediReceiptData[index - 1].uuid)
        this.filter.targetReceiptUuid = targetReceiptUuids
        this.differentSoNo = this.compare(index, index - 1, ediReceiptData, 'soNo')
        this.differentMbl = this.compare(index, index - 1, ediReceiptData, 'mbl')
      }
      if (type === 3) {
        // 重新加载数据
        const targetReceipts = ediReceiptData.filter((item, index) => {
          return this.index !== index
        })
        const targetReceiptUuids = targetReceipts.map(item => {
          return item.uuid
        })
        this.filter.targetReceiptUuid = targetReceiptUuids
        this.differentSoNo = this.compare(index, -1, ediReceiptData, 'soNo')
        this.differentMbl = this.compare(index, -1, ediReceiptData, 'mbl')
      }
      this.reload()
    },
    // 对比数据是否不一致
    compare(sourceIndex, targetIndex, ediReceiptData, compareField) {
      if (sourceIndex === 0 || this.filter.differentStatus === '' || this.filter.differentStatus === 1) {
        return false
      }
      if (targetIndex > 0) {
        return ediReceiptData[sourceIndex][compareField] !== ediReceiptData[targetIndex][compareField]
      }
      for (const item of ediReceiptData) {
        if (item.uuid !== ediReceiptData[sourceIndex].uuid) {
          if (ediReceiptData[sourceIndex][compareField] !== item[compareField]) {
            return true
          }
        }
      }
      return false
    },
    bookingConfirmationLabel() {
      if (this.selectData) {
        switch (this.selectData.status) {
          case '1':
            return 'Cancellation'
          case '5':
            return 'Replacement'
          case '9':
            return 'Original'
          default:
            return ''
        }
      }
      return ''
    },
    locationLabel(data) {
      const color = 'style="color:sandybrown"'
      const isDifferent = data['differentFields'] && data['differentFields']['portCode']
      return '<span ' + (isDifferent ? color : '') + '>' + data.portName + '</br>(' + data.portCode + ')' + '</span>'
    },
    setCellColor(data, field) {
      const isDifferent = data['differentFields'] && data['differentFields'][field]
      return isDifferent ? { color: 'sandybrown' } : {}
    },
    syncData() {
      const port = this.port.rowData
      if (port && port.length > 0) {
        const port20s = port.filter(item => { return item.transportCode === '20' })
        const port10s = port.filter(item => { return item.transportCode === '10' })
        const data = {}
        data['soNo'] = this.selectData.soNo
        data['mbl'] = this.selectData.mbl
        if (port20s && port20s.length > 0) {
          const port20 = port20s[0]
          data['vessel'] = port20.vessel
          data['voyage'] = port20.voyage
          data['imoCode'] = port20.imoCode
        }
        if (port10s && port10s.length > 0) {
          const port10 = port10s[0]
          data['bargeVessel'] = port10.vessel
          data['bargeVoyage'] = port10.voyage
          data['hasTDT10'] = true
        }
        this.$emit('syncBC', data)
      }
    }
  }
}
</script>

<style lang="scss">
.booking-confirmation {
  .warning{
    color: sandybrown;
  }
  .el-descriptions{
    background-color: transparent;
    margin-bottom: 10px;
    &__body{
      background-color: transparent;
    }
    &__header {
      margin-top: 10px;
      margin-bottom: 5px;
    }
    &__title{
      flex: 1;
      text-align: center;
    }
    .is-border{
      .el-descriptions-row{
        td {
          border-color: #DCDFE6!important;
        }
        th {
          border-color: #DCDFE6!important;
        }
      }
    }
    .is-bordered-label {
       background-color: #EBEEF5;
     }
    &-item {
      &__label{
        color:#333!important;
      }
      &__content {
        p{
          margin-top: 0;
          &:nth-last-child(1){
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .show-more {
    cursor: pointer;
    color: #1F75D5;
    text-align: center;
  }
}
</style>
